import { Chip, Tooltip } from "@mui/material";
import React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { EnumHelper } from "ui/Scripts/source/models/enums";

interface IRiskListApprovalChipProps {
    icon?: React.ReactElement;
    approval: number;
    fullWidth?: boolean;
}

export const RiskListApprovalChip = (props: IRiskListApprovalChipProps) => {
    const color = EnumHelper.getApprovalTypeColor(props.approval);
    const textColor = Base.invertColor(color, true);
    const text = EnumHelper.getApprovalTypeText(props.approval);

    return (
        <Tooltip title={text}>
            <Chip
                icon={props.icon}
                label={text}
                size="small"
                sx={{ backgroundColor: color, color: textColor, width: props.fullWidth ? "100%" : null }}
            />
        </Tooltip>
    );
};
